
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface PatientSearchInputProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export function PatientSearchInput({ searchQuery, onSearchChange }: PatientSearchInputProps) {
  return (
    <div className="relative w-64">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
      <Input
        placeholder="Search patients..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
}
